import { render, staticRenderFns } from "./SendFacebookPetition.vue?vue&type=template&id=8138942a"
import script from "./SendFacebookPetition.vue?vue&type=script&lang=js"
export * from "./SendFacebookPetition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports